import { render, staticRenderFns } from "./month.vue?vue&type=template&id=48830104&scoped=true&"
import script from "./month.vue?vue&type=script&lang=js&"
export * from "./month.vue?vue&type=script&lang=js&"
import style0 from "./month.vue?vue&type=style&index=0&id=48830104&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48830104",
  null
  
)

export default component.exports